import * as actionTypes from "../actions/actionTypes";

const initialState = {
	isAuthenticated: false,
	userDetails: null,
	selectedEnvironment: "bhs",
	userType: "",
	loginModalShow: false,
	favorites: null,
	fav_retries: 0,
	fetchingFavorites: false,
	fetchingAddRemoveFavorites: false,
};
const reducer = (state = initialState, action) => {
	switch (action.type) {
		case actionTypes.LOGOUT_SUCCEED: {
			return initialState;
		}
		case actionTypes.UPDATE_LANGUAGE: {
			if (action.payload)
				return {
					...state,
					selectedEnvironment: action.payload,
				};
			return state;
		}
		case actionTypes.LOGIN_SUCCEED_REDUX: {
			return {
				...state,
				isAuthenticated: true,
				userDetails: action.payload,
			};
		}
		case actionTypes.OPEN_LOGIN_MODAL: {
			return {
				...state,
				loginModalShow: true,
			};
		}
		case actionTypes.CLOSE_LOGIN_MODAL: {
			return {
				...state,
				loginModalShow: false,
			};
		}
		case actionTypes.FETCH_FAVORITES: {
			return {
				...state,
				fetchingFavorites: true,
			};
		}
		case actionTypes.FETCH_FAVORITES_SUCCESS: {
			return {
				...state,
				favorites: action.payload,
				loginModalShow: false,
				fav_retries: 0,
			};
		}
		case actionTypes.FETCH_FAVORITES_FAILED: {
			return {
				...state,
				favorites: null,
				loginModalShow: false,
				fav_retries: state?.fav_retries + 1,
			};
		}
		case actionTypes.FETCH_FAVORITES_FAILED_MAX_RETRIES: {
			return {
				...state,
				favorites: null,
				loginModalShow: false,
				fav_retries: 0,
			};
		}
		case actionTypes.ADD_REMOVE_FAVORITE: {
			return {
				...state,
				fetchingAddRemoveFavorites: true,
			};
		}
		case actionTypes.COMPLETE_ADD_REMOVE_FAVORITE: {
			return {
				...state,
				fetchingAddRemoveFavorites: false,
			};
		}
		default:
			return state;
	}
};
export default reducer;
